import styled from 'styled-components';

export const DocumentPreviewContainer = styled.div`
  & object {
    min-height: 500px;
  }
`;
